// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(max-width: 900px){
  .hideMobile {
    display: none;
  }
  mat-form-field {
    width: 140px;
  }
}

@media(min-width: 900px){

    /* filter date */
  .hideDesktop {
    display: none !important;
  }

}

.disabledInput {
  color: rgba(0,0,0,.26);
}
`, "",{"version":3,"sources":["webpack://./src/app/sale/sale-filter/sale-filter.component.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;;AAEA;;IAEI,gBAAgB;EAClB;IACE,wBAAwB;EAC1B;;AAEF;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["@media(max-width: 900px){\n  .hideMobile {\n    display: none;\n  }\n  mat-form-field {\n    width: 140px;\n  }\n}\n\n@media(min-width: 900px){\n\n    /* filter date */\n  .hideDesktop {\n    display: none !important;\n  }\n\n}\n\n.disabledInput {\n  color: rgba(0,0,0,.26);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
